import React, { FC } from 'react';
import { CopyMagicPropsInterface } from '../CopyMagic.types';

import { ConfigProvider, UiResourceProvider, ResultProvider } from './index';
import { MessagesProvider } from './MessagesContext';

/*
All generators use:
  - ConfigProvider
  - UiResourceProvider

Generators ContentAssistant, CourseOutline, HeadlineAssistant use:
  - ResultProvider

Generator ConversationAssistant uses:
  - MessagesProvider
*/

const withCopyMagicProvider = (WrappedComponent: FC) => (props: CopyMagicPropsInterface) => (
  <ConfigProvider copyMagicProps={props}>
    <UiResourceProvider>
      <MessagesProvider>
        <ResultProvider>
          <WrappedComponent />
        </ResultProvider>
      </MessagesProvider>
    </UiResourceProvider>
  </ConfigProvider>
);

export default withCopyMagicProvider;
